/**
 * Component Registry for Ctl Management Theme
 * 
 * Extends the base landing-page theme registry with Ctl Management specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';

/**
 * Ctl Management specific component overrides.
 * These components have been customized for the Ctl Management brand.
 * 
 */
import { AmenitiesList } from './components/AmenitiesList';
import { Fees } from './components/Fees';
import { Footer } from './components/Footer';
import { PropertyOverview } from './components/PropertyOverview';

const ctlmanagementOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  Fees,
  Footer,
  PropertyOverview,
};

/**
 * Final merged registry for Ctl Management properties.
 * Inherits all components from the landing-page theme, with Ctl Management overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...ctlmanagementOverrides,
};

export default registry;
